{
  "invoices": {
    "header": {
      "title": "Invoices",
      "title_reimbursement": "Reimbursements",
      "description": "Invoices generated for this organisation.",
      "description_reimbursement": "Reimbursements generated for this organisation."
    },
    "datasets": {
      "aria": "Choose which administration to show",
      "billing": "Billing",
      "reimbursement": "Reimbursement"
    },
    "role": {
      "loading": "Loading your access level…",
      "error": {
        "title": "Could not load your access level",
        "description": "Loading your account details failed. Please try again."
      }
    },
    "noAccess": {
      "title": "No access to invoices",
      "description": "Your account has not been granted access to the invoices module. Contact an administrator if you believe you should have it."
    },
    "organisations": {
      "title": "Organisations in this tenant",
      "loading": "Loading organisations…",
      "columns": {
        "organisation": "Organisation",
        "description": "Description",
        "type": "Type",
        "id": "ID"
      },
      "types": {
        "tenant": "Tenant organisation",
        "domain": "Domain organisation"
      },
      "empty": {
        "title": "No organisations",
        "description": "This tenant has no organisations."
      },
      "error": {
        "title": "Could not load organisations",
        "description": "Loading the tenant's organisations failed. Please try again."
      }
    },
    "list": {
      "title": "Invoices",
      "title_reimbursement": "Reimbursements",
      "titleLatest": "Latest invoices",
      "titleLatest_reimbursement": "Latest reimbursements",
      "count": "{{count}} invoice",
      "count_reimbursement": "{{count}} reimbursement",
      "count_other": "{{count}} invoices",
      "count_reimbursement_other": "{{count}} reimbursements",
      "searchPlaceholder": "Search by invoice number, client or reference",
      "searchPlaceholder_reimbursement": "Search by reimbursement number, client or reference",
      "searchAria": "Search invoices",
      "searchAria_reimbursement": "Search reimbursements",
      "loading": "Loading invoices…",
      "loading_reimbursement": "Loading reimbursements…",
      "columns": {
        "invoice": "Invoice",
        "invoice_reimbursement": "Reimbursement",
        "client": "Client",
        "assignedTo": "Assigned to",
        "date": "Date",
        "status": "Status",
        "amount": "Amount"
      },
      "toasts": {
        "downloadFailed": "Could not download the invoice. Please try again.",
        "downloadFailed_reimbursement": "Could not download the reimbursement. Please try again."
      },
      "status": {
        "concept": "Concept",
        "sent": "Sent",
        "partlyPaid": "Partly paid",
        "paid": "Paid",
        "credit": "Credit",
        "cancelled": "Cancelled",
        "unknown": "Status {{status}}"
      },
      "filters": {
        "aria": "Filter invoices",
        "status": "Status",
        "month": "Month",
        "monthAria": "Filter by month",
        "allMonths": "All months",
        "clear": "Clear filters"
      },
      "empty": {
        "title": "No invoices",
        "title_reimbursement": "No reimbursements",
        "description": "No invoices are visible for your account. Invoices appear once your clients are linked and invoiced.",
        "description_reimbursement": "No reimbursements are visible for your account. They appear once your clients are linked and a reimbursement has been issued."
      },
      "noResults": {
        "title": "No matches",
        "description": "Nothing matches the current search and filters. Try a different term, or clear the filters."
      },
      "error": {
        "title": "Could not load invoices",
        "title_reimbursement": "Could not load reimbursements",
        "description": "Loading the invoices from the invoicing system failed. Please try again.",
        "description_reimbursement": "Loading the reimbursements from the invoicing system failed. Please try again."
      }
    },
    "detail": {
      "eyebrow": "Invoice",
      "eyebrow_reimbursement": "Reimbursement",
      "loading": "Loading invoice details…",
      "loading_reimbursement": "Loading reimbursement details…",
      "close": "Close",
      "download": "Download invoice",
      "download_reimbursement": "Download reimbursement",
      "outstanding": "{{amount}} outstanding",
      "invoiceTotal": "Invoice total",
      "invoiceTotal_reimbursement": "Reimbursement total",
      "error": {
        "title": "Could not load the invoice",
        "title_reimbursement": "Could not load the reimbursement",
        "description": "Loading the invoice's details from the invoicing system failed. Please try again.",
        "description_reimbursement": "Loading the reimbursement's details from the invoicing system failed. Please try again."
      },
      "sections": {
        "details": "Invoice details",
        "details_reimbursement": "Reimbursement details",
        "amounts": "Amounts",
        "description": "Description",
        "lines": "Lines",
        "attachments": "Attachments"
      },
      "attachments": {
        "download": "Download",
        "failed": "Could not download {{name}}. Please try again."
      },
      "fields": {
        "code": "Invoice number",
        "code_reimbursement": "Reimbursement number",
        "client": "Client",
        "clientReference": "Client reference",
        "clientEmail": "Email address",
        "assignedTo": "Assigned to",
        "date": "Invoice date",
        "date_reimbursement": "Reimbursement date",
        "dueDate": "Due date",
        "sentDate": "Date sent",
        "paidDate": "Date paid",
        "paymentMethod": "Payment method",
        "reference": "Reference",
        "modified": "Last modified"
      },
      "amounts": {
        "excl": "Subtotal (excl. VAT)",
        "tax": "VAT",
        "incl": "Total (incl. VAT)",
        "paid": "Paid",
        "outstanding": "Outstanding"
      },
      "lines": {
        "columns": {
          "description": "Description",
          "quantity": "Quantity",
          "priceExcl": "Unit price",
          "tax": "VAT"
        },
        "quantity": "{{quantity}} {{unit}}",
        "tax": "{{percentage}}%"
      }
    },
    "clients": {
      "title": "Invoice clients",
      "title_reimbursement": "Reimbursement clients",
      "count": "{{count}} client",
      "count_other": "{{count}} clients",
      "searchPlaceholder": "Search by client, email, reference or city",
      "searchAria": "Search invoice clients",
      "searchAria_reimbursement": "Search reimbursement clients",
      "loading": "Loading invoice clients…",
      "loading_reimbursement": "Loading reimbursement clients…",
      "notLinked": "Not linked",
      "kinds": {
        "tenant": "Tenant",
        "organisation": "Organisation"
      },
      "columns": {
        "client": "Client",
        "reference": "Reference",
        "linkedTo": "Linked to",
        "combineInvoices": "Combine invoices",
        "actions": "Actions"
      },
      "combineInvoices": {
        "combined": "Combined"
      },
      "actions": {
        "add": "New client",
        "link": "Manage links"
      },
      "empty": {
        "title": "No clients",
        "description": "No clients match the current search."
      },
      "error": {
        "title": "Could not load invoice clients",
        "title_reimbursement": "Could not load reimbursement clients",
        "description": "Loading the clients from the invoicing system failed. Please try again."
      },
      "dialog": {
        "title": "Manage links",
        "description": "Link {{name}} to the tenants or organisations its invoices belong to.",
        "description_reimbursement": "Link {{name}} to the tenants or organisations its reimbursements belong to.",
        "fields": {
          "tenant": "Tenant",
          "tenantPlaceholder": "Select a tenant…",
          "organisation": "Organisation"
        },
        "wholeTenant": "Whole tenant",
        "organisationHint": "Leave on “Whole tenant” to link the entire tenant, or pick one organisation within it.",
        "errors": {
          "tenant": "Select a tenant.",
          "alreadyLinked": "This client is already linked to that target."
        },
        "currentLinks": "Linked to",
        "noLinks": "Not linked to any tenant or organisation yet — its invoices are not attributed to anyone.",
        "noLinks_reimbursement": "Not linked to any tenant or organisation yet — its reimbursements are not attributed to anyone.",
        "addLink": "Add a link",
        "add": "Add link",
        "close": "Close",
        "removeLink": "Remove the link to {{name}}"
      },
      "details": {
        "title": "Client details",
        "loading": "Loading client details…",
        "close": "Close",
        "edit": "Edit client",
        "error": {
          "title": "Could not load client details",
          "description": "Loading the client's details from the invoicing system failed. Please try again."
        },
        "fields": {
          "companyName": "Company",
          "debtorCode": "Debtor code",
          "companyNumber": "Company number",
          "taxNumber": "VAT number",
          "contactName": "Contact",
          "email": "Email",
          "phoneNumber": "Phone",
          "mobileNumber": "Mobile",
          "address": "Address",
          "zipCode": "Postal code",
          "city": "City",
          "country": "Country",
          "iban": "IBAN",
          "bic": "BIC",
          "accountName": "Account holder",
          "bank": "Bank",
          "currency": "Currency",
          "comment": "Comment",
          "modified": "Last modified",
          "linkedTo": "Linked to",
          "houseStyle": "House style",
          "combineInvoices": "Combine invoices"
        },
        "combineInvoices": {
          "yes": "Yes, one combined invoice",
          "no": "No, separate invoices"
        }
      },
      "form": {
        "addTitle": "New client",
        "editTitle": "Edit client",
        "description": "Client details as held by the invoicing system. Changes are saved there directly.",
        "nameHint": "Fill in a company name, a surname, or both - the invoicing system needs at least one.",
        "debtorCodePlaceholder": "Assigned automatically (CMX-...)",
        "addDescription": "The new client is created in both the billing and the reimbursement administration, under one client code. Later changes are saved per administration.",
        "countryPlaceholder": "e.g. NL",
        "currencyPlaceholder": "e.g. EUR",
        "houseStyleHint": "The layout and language the invoicing system sends this client's invoices in.",
        "combineInvoicesHint": "All of this client's invoices are combined into one. This applies to the client as a whole, not per reimbursement split.",
        "sections": {
          "company": "Company",
          "contact": "Contact",
          "address": "Address",
          "billing": "Bank details",
          "invoicing": "Invoicing"
        },
        "sex": {
          "unspecified": "Not specified",
          "m": "Mr.",
          "f": "Mrs.",
          "d": "Mx.",
          "fam": "Family",
          "u": "Unknown"
        },
        "fields": {
          "companyName": "Company",
          "debtorCode": "Debtor code",
          "companyNumber": "Company number",
          "taxNumber": "VAT number",
          "sex": "Salutation",
          "initials": "Initials",
          "surName": "Surname",
          "email": "Email",
          "phoneNumber": "Phone",
          "mobileNumber": "Mobile",
          "address": "Address",
          "zipCode": "Postal code",
          "city": "City",
          "country": "Country",
          "iban": "IBAN",
          "bic": "BIC",
          "accountName": "Account holder",
          "bank": "Bank",
          "currency": "Currency",
          "comment": "Comment",
          "houseStyle": "House style",
          "combineInvoices": "Combine all invoices into one"
        },
        "errors": {
          "name": "Fill in a company name or a surname.",
          "email": "Enter a valid email address.",
          "saveFailed": "Could not save the client. Please try again."
        },
        "cancel": "Cancel",
        "create": "Create client",
        "save": "Save changes"
      },
      "toasts": {
        "linked": "Linked {{name}}.",
        "unlinked": "Removed the link to {{name}}.",
        "created": "Client {{name}} created.",
        "updated": "Client {{name}} updated.",
        "saveFailed": "Could not save the link. Please try again.",
        "unlinkFailed": "Could not remove the link. Please try again."
      },
      "moreLinks": "+{{count}} more",
      "moreLinks_other": "+{{count}} more"
    }
  },
  "fees": {
    "header": {
      "title": "Fees",
      "description": "What a customer pays NRG per charging point, per tenant or organisation.",
      "description_reimbursement": "NRG's cut of each tariff component on the reimbursement side, per tenant or organisation."
    },
    "loading": "Loading your access…",
    "error": {
      "title": "Could not determine your access",
      "description": "Loading your IAM scope failed. Please try again."
    },
    "noAccess": {
      "title": "Domain only",
      "description": "Fees are what NRG earns, so only domain users can view and manage them."
    },
    "datasets": {
      "aria": "Choose which administration to show",
      "billing": "Billing",
      "reimbursement": "Reimbursement"
    },
    "service": {
      "title": "Service fees",
      "count": "{{count}} organisation",
      "count_other": "{{count}} organisations",
      "searchPlaceholder": "Search by tenant or organisation",
      "searchAria": "Search service fees",
      "add": "Add service fee",
      "nothing": "No cut on any component",
      "columns": {
        "target": "Tenant / organisation",
        "fee": "Service fee"
      },
      "kind": {
        "tenant": "Tenant",
        "organisation": "Organisation"
      },
      "actions": {
        "edit": "Edit service fee",
        "delete": "Remove service fee"
      },
      "empty": {
        "title": "No service fees",
        "description": "No tenant or organisation has a service fee configured. Without one we take no cut, and the whole location price is available to split."
      },
      "error": {
        "title": "Could not load service fees",
        "description": "Loading the service fees failed. Please try again."
      },
      "dialog": {
        "addTitle": "Add service fee",
        "editTitle": "Edit service fee",
        "description": "Our cut of each tariff component, taken before the rest is split between the parties. It applies to every location the target has, so it isn't checked against any single price here - the split dialog does that per location.",
        "wholeTenant": "Whole tenant",
        "wholeTenantHint": "Leave the organisation empty to set the fee for the whole tenant. A fee on a single organisation overrides its tenant's.",
        "sections": {
          "value": "Cut per component"
        },
        "fields": {
          "target": "Applies to",
          "tenant": "Tenant",
          "tenantPlaceholder": "Select a tenant…",
          "organisation": "Organisation"
        },
        "errors": {
          "tenant": "Select a tenant.",
          "tenantTaken": "This tenant already has a service fee. Pick one of its organisations to override it, or edit the tenant's own fee."
        },
        "cancel": "Cancel",
        "create": "Add service fee",
        "save": "Save changes"
      },
      "deleteDialog": {
        "title": "Remove service fee",
        "description": "Remove the service fee for {{name}}? Anything relying on it falls back to its tenant's fee, or to no cut at all.",
        "confirm": "Remove service fee"
      },
      "toasts": {
        "created": "Service fee for {{name}} set.",
        "updated": "Service fee for {{name}} updated.",
        "deleted": "Service fee for {{name}} removed.",
        "saveFailed": "Could not save the service fee. Please try again.",
        "deleteFailed": "Could not remove the service fee. Please try again."
      }
    },
    "billing": {
      "title": "Billing fees",
      "count": "{{count}} organisation",
      "count_other": "{{count}} organisations",
      "searchPlaceholder": "Search by tenant or organisation",
      "searchAria": "Search billing fees",
      "add": "Add billing fee",
      "nothing": "No fee",
      "perChargingPoint": "{{value}} per charging point",
      "columns": {
        "target": "Tenant / organisation",
        "fee": "Billing fee",
        "chargingPoints": "Charging points",
        "total": "Total"
      },
      "kind": {
        "tenant": "Tenant",
        "organisation": "Organisation"
      },
      "actions": {
        "edit": "Edit billing fee",
        "delete": "Remove billing fee"
      },
      "empty": {
        "title": "No billing fees",
        "description": "No tenant or organisation has a billing fee configured."
      },
      "error": {
        "title": "Could not load billing fees",
        "description": "Loading the billing fees failed. Please try again."
      },
      "dialog": {
        "addTitle": "Add billing fee",
        "editTitle": "Edit billing fee",
        "description": "What the customer pays us per charging point. It applies to every charging point the target has.",
        "wholeTenant": "Whole tenant",
        "wholeTenantHint": "Leave the organisation empty to set the fee for the whole tenant. A fee on a single organisation overrides its tenant's.",
        "sections": {
          "value": "Fee"
        },
        "fields": {
          "target": "Applies to",
          "tenant": "Tenant",
          "tenantPlaceholder": "Select a tenant…",
          "organisation": "Organisation",
          "price": "Price per charging point",
          "priceUnit": "€"
        },
        "errors": {
          "tenant": "Select a tenant.",
          "tenantTaken": "This tenant already has a billing fee. Choose one of its organisations to override it, or edit the tenant's own fee."
        },
        "cancel": "Cancel",
        "create": "Add billing fee",
        "save": "Save changes"
      },
      "deleteDialog": {
        "title": "Remove billing fee",
        "description": "Remove the billing fee for {{name}}? Anything relying on it falls back to the tenant's fee, or to no fee at all.",
        "confirm": "Remove billing fee"
      },
      "toasts": {
        "created": "Billing fee for {{name}} set.",
        "updated": "Billing fee for {{name}} updated.",
        "deleted": "Billing fee for {{name}} removed.",
        "saveFailed": "Could not save the billing fee. Please try again.",
        "deleteFailed": "Could not remove the billing fee. Please try again."
      }
    }
  },
  "splitBilling": {
    "header": {
      "title": "Reimbursement split",
      "description": "Divides a location's charging income between parties, each reimbursed their share."
    },
    "splits": {
      "title": "Splits",
      "count": "{{count}} split",
      "count_other": "{{count}} splits",
      "searchPlaceholder": "Search by split, party or reference",
      "searchAria": "Search splits",
      "add": "Add split",
      "units": {
        "perKwh": "{{value}}/kWh",
        "perHour": "{{value}}/h",
        "perSession": "{{value}}/session"
      },
      "components": {
        "energyPricePerKwh": {
          "short": "Energy",
          "unit": "€/kWh"
        },
        "chargingTimePricePerHour": {
          "short": "Charging",
          "unit": "€/h"
        },
        "parkingTimePricePerHour": {
          "short": "Parking",
          "unit": "€/h"
        },
        "flatFeePrice": {
          "short": "Flat fee",
          "unit": "€/session"
        }
      },
      "columns": {
        "name": "Split",
        "location": "Location",
        "users": "Parties"
      },
      "actions": {
        "edit": "Edit split",
        "delete": "Delete split"
      },
      "empty": {
        "title": "No splits",
        "description": "No splits match the current search. Add one to divide a location's tariff between one or more parties."
      },
      "error": {
        "title": "Could not load splits",
        "description": "Loading the splits failed. Please try again."
      },
      "fileFormats": {
        "Xlsx": "Excel (XLSX)",
        "Csv": "CSV"
      },
      "dialog": {
        "addTitle": "Add split",
        "editTitle": "Edit split",
        "description": "Divide each component of a location's tariff between the service fee and one or more parties. The parties are clients of the reimbursement administration in WeFact, maintained on the invoices page. Only the components the location prices are shown.",
        "sections": {
          "details": "Split details",
          "shares": "Parties"
        },
        "serviceFeeFromTenant": "This service fee is set on the tenant and applies to all its organisations.",
        "locationTariff": "Tariff: {{summary}}",
        "fields": {
          "name": "Name",
          "location": "Location",
          "locationPlaceholder": "Select a location…",
          "user": "Party {{index}}",
          "userPlaceholder": "Select a client…",
          "reference": "Reference",
          "email": "Billing email",
          "componentTariff": "{{component}} cut for party {{user}}",
          "addUser": "Add party",
          "removeUser": "Remove party {{index}}",
          "attachCdr": "Attach sessions file (CDR)",
          "cdrFileFormat": "Sessions file format",
          "houseStyle": "House style"
        },
        "hints": {
          "attachCdr": "Send the sessions file with this party's invoice for this split. Switch it off when the party only wants the amounts."
        },
        "summary": {
          "price": "Tariff",
          "serviceFee": "Service fee",
          "remaining": "Remaining"
        },
        "settlement": {
          "note": "Reimbursements are settled in order of priority. We pay out the first account listed, then continue through your secondary accounts, until the full amount is settled against the station pricing.",
          "moreInfo": "How the payout is calculated",
          "explanation": "The last party listed acts as the balancing account: if the tariff is higher than the total split, they receive the surplus; if it's lower, their share is reduced to match. Any extra charging-card costs are also deducted from their share."
        },
        "errors": {
          "locationTaken": "This location already has an active split. Only one split per location is allowed.",
          "serviceFeeUnavailable": "The service fee couldn't be loaded, so this split can't be checked against the location price. Close the dialog and try again.",
          "shares": "Give every row a client, a reference, a billing email and a cut of at least one component.",
          "partiesUnavailable": "The parties of a split are clients of the reimbursement administration in WeFact, which your account cannot access. Ask for access to the invoices module to pick them.",
          "overAllocated": "The cuts and service fee exceed the location price for: {{components}}."
        },
        "cancel": "Cancel",
        "create": "Create split",
        "save": "Save changes"
      },
      "deleteDialog": {
        "title": "Delete split",
        "description": "Delete split {{name}}? This cannot be undone.",
        "confirm": "Delete split"
      },
      "toasts": {
        "created": "Split {{name}} created.",
        "updated": "Split {{name}} updated.",
        "deleted": "Split {{name}} deleted.",
        "saveFailed": "Could not save the split. Please try again.",
        "deleteFailed": "Could not delete the split. Please try again."
      }
    }
  }
}
